import {Account, AccountProfileFactory} from "../shared/types";
import {
  AccountTypeName,
  getAccountInfoFromEmail,
  PatientAccountProfile,
  ProviderAccountProfile, ServiceAccountProfile,
  StaffAccountProfile
} from "./types";
import {Capacitor} from "@capacitor/core";
import {NotificationService} from "./services/notifications";
import {User} from "@firebase/auth";

export class LibwyzeCommonInit {

  private constructor() {
  }

  static async init(user: User): Promise<void> {
    Account.registerAccountType({
      name: AccountTypeName.PATIENT,
      profileFactory: new class implements AccountProfileFactory<PatientAccountProfile> {
        create(account: Account): PatientAccountProfile {
          return new PatientAccountProfile(account.id, account.member.user.firstname, account.member.user.lastname, account.member.user.profilePhoto, account.member.user.email);
        }
      },
    });
    Account.registerAccountType({
      name: AccountTypeName.PROVIDER,
      profileFactory: new class implements AccountProfileFactory<ProviderAccountProfile> {
        create(account: Account): ProviderAccountProfile {
          return new ProviderAccountProfile(account.id);
        }
      },
    });
    Account.registerAccountType({
      name: AccountTypeName.STAFF,
      profileFactory: new class implements AccountProfileFactory<StaffAccountProfile> {
        create(account: Account): StaffAccountProfile {
          const {practiceId, entityId} = getAccountInfoFromEmail(user.email);
          return new StaffAccountProfile(account.id, practiceId, entityId);
        }
      },
    });
    Account.registerAccountType({
      name: AccountTypeName.SERVICE,
      profileFactory: new class implements AccountProfileFactory<ServiceAccountProfile> {
        create(account: Account): ServiceAccountProfile {
          const {practiceId, entityId} = getAccountInfoFromEmail(user.email);
          return new ServiceAccountProfile(account.id, practiceId, entityId);
        }
      },
    });
  }
}

export class LibwyzePushNotificationsInit {

  private constructor() {
  }

  static async init(): Promise<void> {
    if (Capacitor.isNativePlatform()) {
      const service = NotificationService.getInstance();
      await service.registerNotifications();
      await service.addListeners();
    }
  }
}